module.exports = __webpack_public_path__ + "static/img/40000003.cff62bc6.png";